import {merge} from 'lodash-es';
import {BaseOctopusConfig} from '../../../../base.octopus-config';
import {defaultApiURL} from '../../../../src/app/settings/cycle-4-tne-canope';

const overrideConfig = {
    configuration: {
        http: {
            apiUrl: defaultApiURL,
        }
    }
}

export const Cycle4TneCanopeOctopusConfig = merge({}, BaseOctopusConfig, overrideConfig);